import ThemeInterface from '@/theme-interface'
import { ClickAwayListener, Paper, Popper } from '@mui/material'
import { makeStyles } from '@mui/styles'
import React, { ReactNode } from 'react'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  paper: {
    backgroundColor: theme.mode.backgroundColor.default,
    boxShadow: 'none',
  },
}), { name: 'SimplePopper' })

interface SimplePopperProps {
  open: boolean,
  anchorEl: Element,
  children: ReactNode,
  popperOptions?: object,
  onClose: () => void
}

const SimplePopper = (props: SimplePopperProps) => {
  const classes = useStyles()
  const { open, anchorEl, children, onClose, popperOptions = {} } = props

  const handleClose = (): void => {
    onClose()
  }

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      style={{
        zIndex: '1500',
        boxShadow: '0px 3px 10px 0px rgba(0,0,0,0.1), 0px 3px 30px 0px rgba(0,0,0,0.1), 0px 0px 0px 0px rgba(0,0,0,0.1)',
      }}
      popperOptions={{ modifiers: { offset: { offset: '0, 5' } }, ...popperOptions }}
    >
      <Paper classes={{ root: classes.paper }}>
        <ClickAwayListener onClickAway={handleClose}>
          {children}
        </ClickAwayListener>
      </Paper>
    </Popper>
  )
}

export default SimplePopper
